import { render, staticRenderFns } from "./EditPosto.vue?vue&type=template&id=ce2f59ea&"
import script from "./EditPosto.vue?vue&type=script&lang=js&"
export * from "./EditPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports